import React, { useEffect } from 'react';
import { History, Sponsorship, Payment } from '.';
import { WhiteContainer } from '../../../components';
import { MdDateRange } from 'react-icons/md';
import {
  BillingLeftSection,
  BillingLink,
  BillingRightSection,
  BlockContainer,
  SponsorshipDiscountFooter,
  SponsorshipDiscountHeader,
  SponsorshipDiscountHeaderLeft,
  SponsorshipDiscountHeaderRight,
  SponsorshipDiscountHeaderSubtitle,
  SponsorshipDiscountHeaderTitle,
  SponsorshipLevelDiscount,
} from './styles';
import { Route, Routes, useLocation, useNavigate, useParams,  } from 'react-router-dom';
import { GroupAdd, CreditCard } from '../../../assets/icons/icons';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { Admin } from '../../../utils/api';
export default () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const ADMIN = new Admin();
  const STRIPEPK = ADMIN.getStripePK();

  useEffect(() => {
    if (!window.location.href.includes('/admin/billing/')) {
      navigate('/admin/billing/sponsorship');
    }
  }, [history]);

  const stripePromise = loadStripe(STRIPEPK);

  return (
    <Elements
      stripe={stripePromise}
    >
      <WhiteContainer padding="0 0px">
        <BlockContainer>
          <BillingLeftSection data-cy="billing-router">
            <BillingLink className={({ isActive }) => (isActive ? 'active' : '')} to="/admin/billing/sponsorship">
              <GroupAdd />
              <span>Sponsorships</span>
            </BillingLink>
            <BillingLink className={({ isActive }) => (isActive ? 'active' : '')} to="/admin/billing/payment">
              <CreditCard color="#4A4A4A" />
              <span>Payment Method</span>
            </BillingLink>
            <BillingLink className={({ isActive }) => (isActive ? 'active' : '')} to="/admin/billing/history">
              <MdDateRange />
              <span>Billing History</span>
            </BillingLink>
            <SponsorshipLevelDiscount onClick={() => window.open('https://armcare.com/discount/15COACH', '_blank')}>
              <SponsorshipDiscountHeader>
                <SponsorshipDiscountHeaderLeft>
                  <SponsorshipDiscountHeaderTitle>EQUIPMENT</SponsorshipDiscountHeaderTitle>
                  <SponsorshipDiscountHeaderSubtitle>DISCOUNT</SponsorshipDiscountHeaderSubtitle>
                </SponsorshipDiscountHeaderLeft>
                <SponsorshipDiscountHeaderRight>
                  <span>15%</span>
                </SponsorshipDiscountHeaderRight>
              </SponsorshipDiscountHeader>
              <SponsorshipDiscountFooter>
                <span>On orders of $500 or more</span>
              </SponsorshipDiscountFooter>
            </SponsorshipLevelDiscount>
          </BillingLeftSection>
          <BillingRightSection data-cy="billing-section">
            <Routes>
              <Route path={`:billingId`} element={<BillingRouter />} />
            </Routes>
          </BillingRightSection>
        </BlockContainer>
      </WhiteContainer>
    </Elements>
  );
};

const BillingRouter = () => {
  const { billingId } = useParams() as any;

  return (
    <>
      {billingId === 'sponsorship' && <Sponsorship />}
      {billingId === 'payment' && <Payment />}
      {billingId === 'history' && <History />}
    </>
  );
};
